import { AuxRadioGroup } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetCurrentSortBy } from "components/widgets/hooks/use-current-widget";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusSortBy } from "store/current-dashboard";
import { SortByTypes } from "store/current-dashboard/types";
import { getCurrentLocalTime } from "common/date-utils";
const { name, sortBy, value } = language.en.skeleton.settingsMenu.sort;
const dataRadioSortBy = [
    { disabled: false, eventData: SortByTypes.Value, label: value },
    { disabled: false, eventData: SortByTypes.Name, label: name }
];
export const InsSettingsSortBy = (props) => {
    const dispatch = useDispatch();
    const { sectionId, widgetId } = props;
    const sortedBy = useWidgetCurrentSortBy(sectionId, widgetId);
    const onRadioGroupChanged = (data) => {
        appInsightsTrackEvent({
            name: appInsightEvents.customEvents.names.ChangeWidgetSettingsSorting,
            properties: { LocalTimestamp: getCurrentLocalTime() }
        }, {
            selectedSortOrder: data.detail.value.label
        });
        dispatch(setCurrentStatusSortBy({ sectionId, sortBy: data.detail.value.eventData, widgetId }));
    };
    dataRadioSortBy.forEach((e) => {
        e.checked = e.eventData === sortedBy;
    });
    return React.createElement(AuxRadioGroup, { key: sortedBy, data: dataRadioSortBy, label: sortBy, onRadioGroupChanged: onRadioGroupChanged });
};
